import { Radio } from '@iwoca/orion';
import { t } from '@lingui/core/macro';
import clsx from 'clsx';
import { useReviewOffer } from 'components/ReviewOffer/ReviewOffer.context';
import { Offer, ProductType } from '../SummaryCard.helpers';
import styles from './ProductTypeSelector.module.css';

type TProps = {
  selectedType: ProductType | null;
};

type TCardProps = {
  id: ProductType;
  title: string;
  description: string;
  selectedType: ProductType | null;
};

const ProductTypeCard = ({
  id,
  title,
  description,
  selectedType,
}: TCardProps) => {
  const { setSelectedProductType, setSelectedOfferId, setOfferDecision } =
    useReviewOffer();

  const isSelected = id === selectedType;

  const onChange = (type: ProductType) => {
    setSelectedProductType(type);
    setSelectedOfferId('');
    setOfferDecision(Offer.UNDECIDED);
  };

  return (
    <Radio.Root
      className={clsx(styles.card, { [styles.cardSelected]: isSelected })}
    >
      <Radio.Label htmlFor={id} className={styles.cardLabel}>
        <div>
          <p className={styles.cardTitle}>{title}</p>
          <p className={styles.cardDescription}>{description}</p>
        </div>
      </Radio.Label>
      <Radio.Input
        id={id}
        value={id}
        checked={isSelected}
        onChange={() => onChange(id)}
      />
    </Radio.Root>
  );
};

export const ProductTypeSelector = ({ selectedType }: TProps) => {
  return (
    <Radio.Group name="product-type" className={styles.container}>
      <ProductTypeCard
        id={ProductType.FLEXI}
        title={t`Flexi-Loan`}
        description={t`Installment loan with a regular repayment plan. Additional loan amounts and extra repayments are possible at any time free of charge.`}
        selectedType={selectedType}
      />
      <ProductTypeCard
        id={ProductType.RCF}
        title={t`Flexi-Revolving-Credit`}
        description={t`A 12-month repayment-free period with access to the full credit limit. Withdrawals and repayments are possible at any time free of charge.`}
        selectedType={selectedType}
      />
    </Radio.Group>
  );
};
